/*
  KS Uppsälj och fri frakt (Kunskapstavlan 2026-09-21). Egen kod, prefix ks-up.
  - Tilläggskortet (snippets/ks-up-card.liquid): "Lägg båda" lägger huvudprodukten (valt format) + tillägget
    och öppnar varukorgen. "+ Lägg till" lägger bara tillägget, varukorgen öppnas inte, kortet visar bekräftelse + Ångra.
    Kortet hämtas på nytt från servern (?section_id=ks-up-card) när varukorgen ändras och när formatet byts,
    så all logik (fri frakt, etiketter, texter) finns på ett ställe i Liquid.
  - Varukorgen (snippets/ks-up-cart.liquid): "+ Lägg till" lägger varan och uppdaterar varukorgen.
  - Snabbvyn: öppnas från bild/namn med data-ks-up-qv. Innehåll från ?section_id=ks-up-quickview.
*/
(() => {
  if (window.KsUpsell) return;

  const cfgEl = document.getElementById('ks-up-config');
  let cfg = {};
  try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) {}

  const cartDrawer = () => document.querySelector('cart-drawer');
  const drawerSections = () => {
    const c = cartDrawer();
    if (c && typeof c.getSectionsToRender === 'function') return c.getSectionsToRender().map((s) => s.id);
    return [];
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) {
      const msg = data.description || data.message || cfg.cartError || 'Something went wrong. Please try again.';
      throw new Error(msg);
    }
    return data;
  }

  function notifyCart(data) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ks-upsell', cartData: data });
      }
    } catch (e) {}
  }

  function renderDrawer(data, open) {
    const c = cartDrawer();
    if (c && data && data.sections && typeof c.renderContents === 'function') {
      const isClosed = !document.body.classList.contains('page-overlay-cart-on');
      c.renderContents(data, open ? isClosed : false);
    } else if (open) {
      window.location = (window.routes && window.routes.cart_url) || root + 'cart';
    } else {
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
    }
  }

  function busy(btn, on) {
    if (!btn) return;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    else { btn.removeAttribute('aria-busy'); btn.disabled = false; }
  }

  function showError(scope, msg) {
    const el = scope && scope.querySelector('[data-ks-up-error]');
    if (el) { el.textContent = msg; el.hidden = false; }
    else console.warn('KS Uppsälj:', msg);
  }

  /* ---------- Tilläggskortet ---------- */

  function cardSectionUrl(productUrl, sectionId) {
    const u = new URL(productUrl, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  async function refreshCard(card, opts = {}) {
    if (!card || !card.isConnected) return;
    const url = opts.productUrl || card.dataset.productUrl;
    if (!url) return;
    const sectionId = card.dataset.sectionId;
    try {
      const html = await fetch(cardSectionUrl(url, 'ks-up-card'), { credentials: 'same-origin' }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-ks-up-card]');
      if (!fresh || !card.isConnected) return;
      if (sectionId) fresh.dataset.sectionId = sectionId;
      if (opts.justAdded && fresh.dataset.mode === 'confirm') fresh.hidden = false;
      card.replaceWith(fresh);
    } catch (e) {
      console.warn('KS Uppsälj: kunde inte uppdatera kortet', e);
    }
  }

  function refreshAllCards(opts) {
    document.querySelectorAll('[data-ks-up-card]').forEach((c) => refreshCard(c, opts));
  }

  function mainVariantId(card) {
    const sid = card.dataset.sectionId;
    if (sid) {
      const input = document.querySelector('#product-form-' + CSS.escape(sid) + ' [name="id"]');
      if (input && input.value) return input.value;
    }
    return card.dataset.mainVariant;
  }

  async function addBoth(card, btn) {
    const main = mainVariantId(card);
    const up = card.dataset.upVariant;
    if (!main || !up) return;
    busy(btn, true);
    try {
      const data = await postJSON(root + 'cart/add.js', {
        items: [{ id: Number(main), quantity: 1 }, { id: Number(up), quantity: 1 }],
        sections: drawerSections(),
        sections_url: window.location.pathname,
      });
      renderDrawer(data, true);
      notifyCart(data);
      await refreshCard(card);
    } catch (e) {
      showError(card, e.message);
    } finally {
      busy(btn, false);
    }
  }

  async function addOne(btn, context) {
    const id = btn.dataset.ksUpAdd;
    const card = btn.closest('[data-ks-up-card]');
    busy(btn, true);
    try {
      const data = await postJSON(root + 'cart/add.js', {
        items: [{ id: Number(id), quantity: 1 }],
        sections: drawerSections(),
        sections_url: window.location.pathname,
      });
      renderDrawer(data, false);
      notifyCart(data);
      if (card) await refreshCard(card, { justAdded: true });
      else refreshAllCards();
    } catch (e) {
      busy(btn, false);
      showError(card || btn.closest('.ks-up-citem'), e.message);
      return;
    }
    if (context !== 'cart') busy(btn, false);
  }

  async function undo(btn) {
    const key = btn.dataset.ksUpUndo;
    const card = btn.closest('[data-ks-up-card]');
    busy(btn, true);
    try {
      const data = await postJSON(root + 'cart/change.js', {
        id: key,
        quantity: 0,
        sections: drawerSections(),
        sections_url: window.location.pathname,
      });
      renderDrawer(data, false);
      notifyCart(data);
      await refreshCard(card);
    } catch (e) {
      busy(btn, false);
      showError(card, e.message);
    }
  }

  /* ---------- Snabbvyn ---------- */

  let qv = null;
  let qvOpener = null;
  let qvAction = null;

  function buildQv() {
    if (qv) return qv;
    qv = document.createElement('div');
    qv.className = 'ks-up-qv';
    qv.innerHTML =
      '<div class="ks-up-qv__overlay" data-ks-up-qv-close></div>' +
      '<div class="ks-up-qv__sheet" role="dialog" aria-modal="true" tabindex="-1">' +
      '<div class="ks-up-qv__top">' +
      (cfg.handle !== false ? '<span class="ks-up-qv__handle" aria-hidden="true"></span>' : '') +
      '<button type="button" class="ks-up-qv__close" data-ks-up-qv-close aria-label="' + (cfg.closeLabel || 'Close') + '">' + (cfg.closeIcon || '×') + '</button>' +
      '</div>' +
      '<div class="ks-up-qv__scroll" data-ks-up-qv-body></div>' +
      '<div class="ks-up-qv__foot"><p class="ks-up-qv__adds" data-ks-up-qv-adds hidden></p>' +
      '<button type="button" class="ks-up-qv__btn" data-ks-up-qv-btn><span class="ks-up-btn__label"></span></button></div>' +
      '</div>';
    document.body.appendChild(qv);

    qv.addEventListener('click', (e) => {
      if (e.target.closest('[data-ks-up-qv-close]')) closeQv();
    });
    qv.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); closeQv(); return; }
      if (e.key === 'Tab') {
        const f = Array.from(qv.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    qv.querySelector('[data-ks-up-qv-btn]').addEventListener('click', async (e) => {
      if (!qvAction) return;
      const btn = e.currentTarget;
      busy(btn, true);
      try { await qvAction(); closeQv(); }
      catch (err) { console.warn(err); }
      finally { busy(btn, false); }
    });

    // Nedsvep stänger (mobil)
    const sheet = qv.querySelector('.ks-up-qv__sheet');
    let startY = null; let dy = 0;
    sheet.addEventListener('touchstart', (e) => {
      const body = qv.querySelector('[data-ks-up-qv-body]');
      const onTop = e.target.closest('.ks-up-qv__top');
      if (onTop || (body && body.scrollTop <= 0 && !e.target.closest('[data-ks-up-qv-track]'))) {
        startY = e.touches[0].clientY; dy = 0;
      } else startY = null;
    }, { passive: true });
    sheet.addEventListener('touchmove', (e) => {
      if (startY === null) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      if (dy > 0 && window.innerWidth < 750) { sheet.style.transition = 'none'; sheet.style.transform = 'translateY(' + dy + 'px)'; }
    }, { passive: true });
    sheet.addEventListener('touchend', () => {
      if (startY === null) return;
      sheet.style.transition = ''; sheet.style.transform = '';
      if (dy > 90) closeQv();
      startY = null;
    });
    return qv;
  }

  function wireGallery(scope) {
    const track = scope.querySelector('[data-ks-up-qv-track]');
    if (!track) return;
    const count = scope.querySelector('[data-ks-up-qv-count]');
    const dots = scope.querySelectorAll('.ks-up-qv__dot');
    const n = track.children.length;
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (count) count.textContent = (i + 1) + ' / ' + n;
      dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
    }, { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      if (e.key === 'ArrowLeft') track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
  }

  async function openQv(trigger) {
    if (cfg.qv === false) return;
    const url = trigger.dataset.ksUpQv;
    const context = trigger.dataset.ksUpQvContext || 'card';
    const card = trigger.closest('[data-ks-up-card]');
    buildQv();
    qvOpener = trigger;
    const body = qv.querySelector('[data-ks-up-qv-body]');
    const adds = qv.querySelector('[data-ks-up-qv-adds]');
    const btn = qv.querySelector('[data-ks-up-qv-btn]');
    const label = btn.querySelector('.ks-up-btn__label');
    body.innerHTML = '<p class="ks-up-qv__loading">' + (cfg.loading || 'Loading…') + '</p>';
    adds.hidden = true; label.textContent = ''; btn.disabled = true;
    qv.classList.add('is-open');
    document.documentElement.classList.add('ks-up-qv-lock');
    void qv.offsetWidth;
    qv.classList.add('is-visible');
    qv.querySelector('.ks-up-qv__close').focus();

    try {
      const html = await fetch(cardSectionUrl(url, 'ks-up-quickview'), { credentials: 'same-origin' }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-ks-up-qv-content]');
      if (!content) throw new Error('No content');
      body.innerHTML = '';
      body.appendChild(document.importNode(content, true));
      wireGallery(body);
      const sheet = qv.querySelector('.ks-up-qv__sheet');
      const title = body.querySelector('.ks-up-qv__title');
      if (title) { title.id = 'ks-up-qv-title'; sheet.setAttribute('aria-labelledby', 'ks-up-qv-title'); }

      if (card && card.dataset.mode === 'both') {
        label.textContent = card.dataset.btnText || '';
        if (card.dataset.qvLine) { adds.textContent = card.dataset.qvLine; adds.hidden = false; }
        qvAction = () => addBoth(card, card.querySelector('[data-ks-up-both]'));
      } else if (card && card.dataset.mode === 'one') {
        label.textContent = card.dataset.btnText || '';
        const addBtn = card.querySelector('[data-ks-up-add]');
        qvAction = () => addOne(addBtn, 'card');
      } else {
        const node = body.querySelector('[data-ks-up-qv-content]');
        label.textContent = node.dataset.btnText || '';
        const vid = node.dataset.variantId;
        qvAction = async () => {
          const data = await postJSON(root + 'cart/add.js', {
            items: [{ id: Number(vid), quantity: 1 }],
            sections: drawerSections(),
            sections_url: window.location.pathname,
          });
          renderDrawer(data, context !== 'cart');
          notifyCart(data);
          refreshAllCards();
        };
      }
      btn.disabled = content.dataset.available === 'false';
    } catch (e) {
      body.innerHTML = '<p class="ks-up-qv__loading">' + (cfg.error || "We couldn't show this product.") + '</p>';
    }
  }

  function closeQv() {
    if (!qv) return;
    qv.classList.remove('is-visible');
    document.documentElement.classList.remove('ks-up-qv-lock');
    setTimeout(() => { qv.classList.remove('is-open'); }, 300);
    qvAction = null;
    if (qvOpener && qvOpener.isConnected) qvOpener.focus({ preventScroll: true });
  }

  /* ---------- Händelser ---------- */

  document.addEventListener('click', (e) => {
    const t = e.target;
    const both = t.closest('[data-ks-up-both]');
    if (both) { e.preventDefault(); addBoth(both.closest('[data-ks-up-card]'), both); return; }
    const add = t.closest('[data-ks-up-add]');
    if (add) { e.preventDefault(); addOne(add, add.dataset.ksUpContext || 'card'); return; }
    const und = t.closest('[data-ks-up-undo]');
    if (und) { e.preventDefault(); undo(und); return; }
    const q = t.closest('[data-ks-up-qv]');
    if (q && cfg.qv !== false) { e.preventDefault(); openQv(q); return; }
    const sc = t.closest('[data-ks-up-scroll]');
    if (sc) {
      const target = document.getElementById(sc.dataset.ksUpScroll);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  // Formatbyte (KS Formatval): hämta kortet för det valda formatets produkt
  document.addEventListener('ks:format-change', (e) => {
    const url = e.detail && e.detail.productUrl;
    document.querySelectorAll('[data-ks-up-card]').forEach((c) => {
      if (url) c.dataset.productUrl = new URL(url, window.location.origin).pathname;
      refreshCard(c);
    });
  });

  // Varukorgen ändrad någon annanstans (köpknapp, antal, ta bort)
  function subscribeCart() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        if (ev && ev.source === 'ks-upsell') return;
        refreshAllCards();
      });
      return true;
    }
    return false;
  }
  if (!subscribeCart()) document.addEventListener('DOMContentLoaded', subscribeCart);

  window.KsUpsell = { refreshAllCards, openQv, closeQv };
})();
